export const FONT_FAMILY = '"Neue Frutiger World"';

export const FORM_LABEL_SX = {
  fontWeight: 500,
  lineHeight: '120%',
  fontSize: '13px',
  color: '#333239',
  fontFamily: FONT_FAMILY,
  letterSpacing: '0.26px',
};

export const COMPACT_FORM_LABEL_SX = {
  fontFamily: FONT_FAMILY,
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 350,
  lineHeight: '130%',
  letterSpacing: 0,
  color: 'grey.950',
};

export const COMPACT_FIELD_WIDTH = '525px';

export const COMPACT_FIELD_FOCUS_COLOR = 'accent.main';

export const COMPACT_OUTLINED_INPUT_SX = {
  display: 'flex',
  height: '40px',
  padding: '12px 16px !important',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
  borderRadius: '12px !important',
  background: 'rgba(255, 255, 255, 0.95)',
  '& fieldset': {
    borderRadius: '12px !important',
    borderColor: 'rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s ease-in-out',
  },
  '&:hover': { borderColor: 'black !important' },
  '&.Mui-focused': {
    borderColor: `${COMPACT_FIELD_FOCUS_COLOR} !important`,
    boxShadow: `0 0 0 1px ${COMPACT_FIELD_FOCUS_COLOR} !important`,
  },
};

export const COMPACT_INPUT_BASE_SX = {
  padding: '0 !important',
  flex: '1 0 0',
  fontFamily: FONT_FAMILY,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '160%',
};

// ─── Compact placeholder overrides ────────────────────────────────────────────

export const COMPACT_PLACEHOLDER_SX = {
  color: '#A4A4B6',
  opacity: 1,
};

export const buildCompactInputSx = (
  hasError: boolean,
  extraSx?: Record<string, unknown>,
): Record<string, unknown> => ({
  paddingBottom: hasError ? 0 : '1rem',
  ...extraSx,
  '& .MuiOutlinedInput-root': COMPACT_OUTLINED_INPUT_SX,
  '& .MuiInputBase-input::placeholder': COMPACT_PLACEHOLDER_SX,
  '& .MuiInputBase-input': COMPACT_INPUT_BASE_SX,
});
